export const ErrorActions = {
  INITIALIZE_PORTAL: 'initializePortal',
  LOGIN_VERIFIED: 'loginVerified',
  PORTAL_SETTINGS_FETCHED: 'portalSettingsFetched'
};